import { render, staticRenderFns } from "./AcceptStatusSwitch.vue?vue&type=template&id=ab2412c0&scoped=true&lang=pug"
import script from "./AcceptStatusSwitch.vue?vue&type=script&lang=ts"
export * from "./AcceptStatusSwitch.vue?vue&type=script&lang=ts"
import style0 from "./AcceptStatusSwitch.vue?vue&type=style&index=0&id=ab2412c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2412c0",
  null
  
)

export default component.exports